__turbopack_context__.v({
  "postFullMetaDate": "view-module__Zrmqta__postFullMetaDate",
  "postPublishingDateParagraph": "view-module__Zrmqta__postPublishingDateParagraph",
  "postPublishingDateSection": "view-module__Zrmqta__postPublishingDateSection",
});
